@for (data of data(); track $index) {
<div class="content-bar">
  <div class="img-description" [ngClass]="{ 'with-weight': data.weight }">
    @if (data.img) {
    <img [src]="data.img" alt="img" />
    }

    <p
      [style.background]="
        data.weight ? colorDescriptionWeight[data.weight] : ''
      "
      [style]="
        data.weight
          ? 'border-right: 4px solid' + colorsWeight[data.weight || 4]
          : ''
      "
      [ngClass]="{ weight: data.weight }"
    >
      {{ data.description }}
    </p>
  </div>
  <div class="bar">
    <div
      class="bar-colors"
      [style.background]="
        dataType() === chartColorsEnum.singleColor
          ? singleColor
          : dataType() === chartColorsEnum.colorsWeight
          ? colorsWeight[data.weight || 4]
          : allColors[$index]
      "
      [style.width.%]="data.percentage"
    ></div>
  </div>
  <div class="values">
    <p>{{ data.count }} | {{ data.percentage }}%</p>
  </div>
</div>
}
